export default {
  DELETE_FILE_SUCCESS: 'Contenuto è stata cancellata con successo.',
  ADD_CONTENT: 'Aggiungi contenuti da condividere',
  ADD_CONTENT_INFO: 'Carica qui i tuoi documenti, link, immagini o altri materiali per condividerli con i tuoi visitatori.',
  NO_CONTENT: 'Non hai ancora aggiunto alcun file o link!',
  UPLOAD_FILES: 'Carica file',
  ADD_URL: 'Aggiungi URL',
  ADDED_CONTENT: 'File e URL aggiunti',
  URL: 'Url',
  ADD_URL_SUCCESS: 'URL generato e salvato con successo!',
  DISPLAY_NAME: 'Nome da visualizzare',
  BROCHURE: 'Brochure',
  CHOOSE_FILE: 'Seleziona file',
  DRAG_DROP: 'Trascina e rilascia',
  TO_UPLOAD: 'da caricare',
  MAX_FILE_SIZE: 'È consentita una dimensione massima di 3mb',
  MAX_LEN_ERR: 'Lunghezza nome file eccessiva',
  MAX_SIZE_ERR: 'Limite dimensione file eccessiva',
  FILES_UPLOAD_SUCCESS: 'File caricati correttamente'
}
